// /app/javascript/controllers/product_media_controller.js

import { Controller } from "@hotwired/stimulus"
import * as bootstrap from 'bootstrap'

// ... (export default class extends Controller, targets, values are unchanged) ...
export default class extends Controller {
  static targets = ["carousel", "youtubeFrame", "indicators"]
  static values = {
    videoId: String,
    videoSlideIndex: Number
  }

  connect() {
    this.initializeCarousel();
    this.initializeYouTubePlayer();
  }

  disconnect() {
    if (this.carousel) {
      this.carousel.dispose();
    }
    if (this.player) {
      // Check if player and destroy function exist before calling
      if (this.player.destroy) {
        this.player.destroy();
      }
    }
  }

  initializeCarousel() {
    if (this.hasCarouselTarget) {
      // 1. Initialize the carousel instance from the element and its data attributes.
      this.carousel = bootstrap.Carousel.getOrCreateInstance(this.carouselTarget);

      // 2. THIS IS THE FIX: Explicitly command the carousel to start cycling.
      // This ensures auto-play starts on both full refreshes and Turbo visits.
      this.carousel.cycle();

      // 3. Add our event listener to pause video when the slide changes.
      this.carouselTarget.addEventListener('slide.bs.carousel', (event) => {
        if (this.player && typeof this.player.pauseVideo === 'function' && event.from !== this.videoSlideIndexValue) {
          this.player.pauseVideo();
        }
        this.scrollToActiveIndicator(event.to);
      });
    }
  }

  scrollToActiveIndicator(index) {
    if (!this.hasIndicatorsTarget) return;

    const indicator = this.indicatorsTarget.querySelector(`[data-bs-slide-to="${index}"]`);
    if (indicator) {
      const container = this.indicatorsTarget;
      const indicatorRect = indicator.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      
      const scrollLeft = container.scrollLeft + (indicatorRect.left - containerRect.left) - (container.clientWidth / 2) + (indicator.clientWidth / 2);
      
      container.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });
    }
  }

  // ... (the rest of your controller: initializeYouTubePlayer, createPlayer, etc. remains the same) ...

  initializeYouTubePlayer() {
    if (!this.hasYoutubeFrameTarget || !this.hasVideoIdValue) return;

    if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
      const tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      window.onYouTubeIframeAPIReady = () => this.createPlayer();
    } else {
      this.createPlayer();
    }
  }

  createPlayer() {
    this.player = new YT.Player(this.youtubeFrameTarget, {
      events: {
        'onStateChange': this.onPlayerStateChange.bind(this)
      }
    });
  }

  onPlayerStateChange(event) {
    if (event.data === YT.PlayerState.PLAYING) {
      this.carousel.pause();
    }
  }

  scrollToVideoAndPlay() {
    if (!this.carousel) return;

    this.carouselTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
    this.carousel.to(this.videoSlideIndexValue);
    this.carousel.pause();

    setTimeout(() => {
        if (this.player && typeof this.player.playVideo === 'function') {
            this.player.playVideo();
        }
    }, 500);
  }
}